module.exports = __webpack_public_path__ + "static/media/in.87557806.svg";